<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="false">
  <ion-label class="title"> {{ 'ACCOUNT.Y4K.title' | translate }} </ion-label>
  <p>{{ 'ACCOUNT.Y4K.modal.p-1' | translate }}</p>
  <p class="content-headline">{{ 'ACCOUNT.Y4K.modal.subtitle-1' | translate }}</p>
  <div class="step">
    <span>1</span>
    <p>{{ 'ACCOUNT.Y4K.modal.step-1' | translate }}</p>
  </div>
  <div class="step">
    <span>2</span>
    <p>{{ 'ACCOUNT.Y4K.modal.step-2' | translate }}</p>
  </div>
  <div class="step">
    <span>3</span>
    <p>{{ 'ACCOUNT.Y4K.modal.step-3' | translate }}</p>
  </div>
  <p class="content-headline">{{ 'ACCOUNT.Y4K.modal.subtitle-2' | translate }}</p>
  <p>{{ 'ACCOUNT.Y4K.modal.p-2' | translate }}</p>
</ion-content>
